import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import InfoSection from "../../components/home/InfoSection";
import CardSection from "../../components/home/CardSection";
import ListSection from "../../components/home/ListSection";
import Hero from "../helpers/Hero";
import {
  heroData,
  homeObjOne,
  homeObjTwo,
  homeObjThree,
  homeObjFour,
  homeObjFive,
  homeObjSix,
  homeObjSeven,
  footerData,
  bbShopObj
} from "../../pages/BB3Product.js";
import { setProductType } from "../../actions/current";
import BBWInfoSection from "../../components/BBWInfoSection";
import PromotionalBanner from "../../components/PromotionalBanner";
import { fetchSale } from "../../actions/sale"
import styles from "../../styles/product/ProductPage.module.scss";

const BB3Product = (props) => {
  const dispatch = useDispatch();
  const { match } = props;

  useEffect(() => {
    dispatch(setProductType("BB3"));
    sessionStorage.setItem("previousRoute", match.url);
  }, [dispatch, match.url]);

  useEffect(() => {
    dispatch(fetchSale()); //eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={styles.container}>
      <PromotionalBanner placement={"website_homepage"} router={props} />
        <Hero {...heroData} router={props} />
        <div className={styles.infoSectionContainer}>
          <InfoSection {...bbShopObj} />
          <InfoSection {...homeObjOne} />
          <InfoSection {...homeObjTwo} />
          <InfoSection {...homeObjThree} />
          <InfoSection {...homeObjFour} className={styles.infoSectionLast} />
        </div>
        <BBWInfoSection/>
        <ListSection {...homeObjSix} />
        <ListSection {...homeObjSeven} />
        <CardSection {...homeObjFive} />
        <Hero {...footerData} router={props} />
      </div>
    </>
  );
};

export default BB3Product;
